import cabinetStyle from "./MentorCabinet.module.css";
import Style from "../Style.module.css";
import React, {useState} from "react";
import NewStepCombinationModal from "../NewStepCombinationModal";
import * as UserService from "../../api/UserService";
import StepCombinationRow from "./StepCombinationRow";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import PageTips from "../PageTips";
import AddIcon from '@mui/icons-material/Add';
import Banner from "./Banner";
import {useTranslation} from "react-i18next";

function StepCombinations() {
    const { t } = useTranslation('translation', { keyPrefix: 'stepCombinations' });
    const [createModalOpened, setCreateModalOpened] = useState(false)
    const [combinations, setCombinations] = useState()

    function openModal() {
        setCreateModalOpened(true)
    }

    function closeModal() {
        setCreateModalOpened(false)
    }

    function pullCombination() {
        UserService.getCombinations(setCombinations, () => {
        })
    }

    useEffectOnce(() => {
        pullCombination()
    }, []);
    return (
        <>
            {/*<Banner></Banner>*/}
            <div
                className={`${cabinetStyle.addStepCombinationButton} ${Style.buttonBaseText}`}
                onClick={openModal}>
                <AddIcon style={{width: "20px", height: "20px"}}></AddIcon> {t('addCombination')}
            </div>
            <div className={cabinetStyle.mainPageContainer}>
                <PageTips headerText={t('header')}>
                    <div className={Style.h5Heading}>{t('headerText1')}
                    </div>
                    <div><code>{t('headerText2')}</code></div>
                    <div className={Style.bodyBaseText}>{t('headerText3')}
                    </div>
                    <div className={Style.bodyBaseText}>{t('headerText4')} <b>{t('headerText4_1')}</b>.
                    </div>
                    <div className={Style.bodyBaseText}>{t('headerText5')} <b>{t('headerText5_1')}</b>{t('headerText5_2')}
                    </div>
                </PageTips>
                <div>
                    {combinations?.map((item) => {
                        return <StepCombinationRow key={item.id} combination={item}
                                                   pullAllCombinations={pullCombination}></StepCombinationRow>
                    })}
                </div>

                {createModalOpened &&
                    <NewStepCombinationModal onClose={closeModal}
                                             pullAllCombinations={pullCombination}></NewStepCombinationModal>}
            </div>

        </>

    )
}

export default StepCombinations